import { useMemo } from 'react';
import { useAuth } from './useAuth';
import type { OwnerSelectTeamOption } from '@reflex/ui/components/ownership/OwnerSelect';

/**
 * Returns the teams the current user belongs to within the active
 * organization, shaped for `OwnerSelect.teams`. Empty when the user is
 * not on any team, when no org is active, or when orgs are disabled
 * (single-tenant mode).
 *
 * Data flows from `/auth/me` through `useAuth().activeMembership.teams`
 * — see `OrganizationService.listMemberships()`.
 */
export function useMyTeams(): OwnerSelectTeamOption[] {
  const { activeMembership } = useAuth();
  return useMemo(() => {
    const teams = activeMembership?.teams ?? [];
    return teams.map((team) => ({
      ownerTeamId: team.id,
      name: team.name,
    }));
  }, [activeMembership]);
}
